import TextCount from './components/TextCount'
import './App.css'

// Replace your code here
const App = () => <TextCount />

export default App
